import React, { useState } from 'react'
import { PropTypes } from 'prop-types'
import { TabContentBlock, TabLabels, TabsAndContentContainer } from './Tab.styles'

import { Tab, TabContent } from './Tab'

export default function TabsContainer({ title, tabs, width, height }) {
	const [active, setActive] = useState(0)

	const handleClick = (i) => {
		if (i !== active) {
			setActive(i)
		}
	}
	const displayTabs = (tabs || []).filter((r) => !r.disabled)
	const panelHeight = parseFloat(height)

	return (
		<TabsAndContentContainer hasTitle={title}>
			{title && <h2>{title}</h2>}
			<TabLabels>
				{displayTabs.map((tab, i) => (
					<Tab key={tab._key} tab={tab} onClick={() => handleClick(i)} active={active === i} />
				))}
			</TabLabels>
			<TabContentBlock width={width} height={panelHeight}>
				{displayTabs.map((tab, i) => (
					<TabContent key={tab._key} tab={tab} active={active === i} />
				))}
			</TabContentBlock>
		</TabsAndContentContainer>
	)
}

TabsContainer.propTypes = {
	title: PropTypes.string,
	tabs: PropTypes.array,
	width: PropTypes.number,
	height: PropTypes.number,
}
